var m = require('mithril');
var prop = require('mithril/stream');
var loaders = require('../layout/components/loaders');
var pickerRequestState = require('../layout/components/pickerRequestState');
var verticalListItem = require('../components/verticalListItem');
var paginationWithSearch = require('../data/components/paginationWithSearch');

var trees = {};

trees.oninit = function (vnode) {
  var ctrl = this;
  ctrl.startView = false;
  ctrl.selectedNode = vnode.attrs.selectedNode;
  ctrl.newNode = prop();
  ctrl.dataToShow = [];
  pickerRequestState.initialize(ctrl);

  ctrl.getLocations = function () {
    ctrl.actualLevel = prop('Home');
    ctrl.ancestors = prop([{ '@class': 'Home', 'name': 'Home' }]);
    ctrl.selectedNode('');  
    return pickerRequestState.run(ctrl, function () {
      return loaders.requestWithLoader({
        loader: 'main',
        url: '/api/v1/site/',
        method: 'GET'
      })
      .then(function (res) {
        ctrl.locations = res.out_Contains && Array.isArray(res.out_Contains) ? res.out_Contains.filter(c => c.in['@class'] == 'Site').map(r=> r.in) : [];
        ctrl.equipment = res.out_isLocationOf && Array.isArray(res.out_isLocationOf) ? res.out_isLocationOf.filter(r=> r.in['@rid'] != vnode.attrs.equipmentRecord['@rid']).map(r=> r.in) : [];
        ctrl.startView = true;
        ctrl.newNode(true);
      });
    }, { onRetry: ctrl.getLocations, errorMessage: 'Unable to load locations for picker:' });
  }

  ctrl.navigateLocation = function (location) {
    ctrl.startView = false;
    ctrl.actualLevel('Site');
    ctrl.ancestors([ctrl.ancestors()[0], location]);
    ctrl.selectedNode('');
    
    return pickerRequestState.run(ctrl, function () {
      return loaders.requestWithLoader({
        loader: 'main',
        url: '/api/v1/site/' + location['@rid'].slice(1),
        method: 'GET'
      })
      .then(function (res) {
        ctrl.buildings = res.out_isSiteOf && Array.isArray(res.out_isSiteOf) ? res.out_isSiteOf.map(isSiteOfEdge => isSiteOfEdge.in) : [];
        ctrl.equipment = res.out_isLocationOf && Array.isArray(res.out_isLocationOf) ? res.out_isLocationOf.filter(r=> r.in['@rid'] != vnode.attrs.equipmentRecord['@rid']).map(r=> r.in) : [];
        ctrl.startView = true;
        ctrl.newNode(true);
      });
    }, { onRetry: function () { return ctrl.navigateLocation(location); }, errorMessage: 'Unable to load location children for picker:' });
  }
  ctrl.selectNode = function (node) {
    ctrl.selectedNode(node)
  }

  ctrl.navigateBuilding = function (building) {
    ctrl.startView = false;
    ctrl.actualLevel('Building');
    ctrl.ancestors([ctrl.ancestors()[0], ctrl.ancestors()[1], building]);
    ctrl.selectedNode('');
    return pickerRequestState.run(ctrl, function () {
      return loaders.requestWithLoader({
        loader: 'main',
        url: '/api/v1/site/' + building['@rid'].slice(1),
        method: 'GET'
      })
      .then(function (res) {
        ctrl.floors = res.out_hasPart && Array.isArray(res.out_hasPart) ? res.out_hasPart.map(out_hasPartEdge => out_hasPartEdge.in) : [];
        ctrl.equipment = res.out_isLocationOf && Array.isArray(res.out_isLocationOf) ? res.out_isLocationOf.filter(r=> r.in['@rid'] != vnode.attrs.equipmentRecord['@rid']).map(r=> r.in) : [];
        ctrl.startView = true;
        ctrl.newNode(true);
      });
    }, { onRetry: function () { return ctrl.navigateBuilding(building); }, errorMessage: 'Unable to load building children for picker:' });
  }
  
  ctrl.navigateLevel = function (level) {
    ctrl.startView = false;
    ctrl.actualLevel('Level');
    ctrl.ancestors([ctrl.ancestors()[0], ctrl.ancestors()[1], ctrl.ancestors()[2], level]);
    ctrl.selectedNode('');
    return pickerRequestState.run(ctrl, function () {
      return loaders.requestWithLoader({
        loader: 'main',
        url: '/api/v1/site/' + level['@rid'].slice(1),
        method: 'GET'
      })
      .then(function (res) {
        ctrl.rooms = res.out_hasPart && Array.isArray(res.out_hasPart) ? res.out_hasPart.map(out_hasPartEdge => out_hasPartEdge.in) : [];
        ctrl.equipment = res.out_isLocationOf && Array.isArray(res.out_isLocationOf) ? res.out_isLocationOf.filter(r=> r.in['@rid'] != vnode.attrs.equipmentRecord['@rid']).map(r=> r.in) : [];
        ctrl.startView = true;
        ctrl.newNode(true);
      });
    }, { onRetry: function () { return ctrl.navigateLevel(level); }, errorMessage: 'Unable to load level children for picker:' });
  }

  ctrl.navigateEquipment = function (equipment) {
    ctrl.startView = false;
    ctrl.actualLevel('Equipment');
    ctrl.ancestors([...ctrl.ancestors(), equipment]);
    ctrl.selectedNode('');
    ctrl.selectNode('');
    return pickerRequestState.run(ctrl, function () {
      return loaders.requestWithLoader({
        loader: 'main',
        url: '/api/v1/equipment/' + equipment['@rid'].slice(1),
        method: 'GET'
      })
      .then(function (res) {
        ctrl.equipment = res.out_hasComponent && Array.isArray(res.out_hasComponent) ? res.out_hasComponent.map(r=> r.in) : [];
        ctrl.startView = true;
        ctrl.newNode(true);
      });
    }, { onRetry: function () { return ctrl.navigateEquipment(equipment); }, errorMessage: 'Unable to load equipment children for picker:' });
  }
  ctrl.selectNode = function (node) {
    ctrl.selectedNode(node)
  }
  ctrl.getLocations();
}

trees.view = function (vnode) {
  var ctrl = this;
  var stateView = pickerRequestState.view(ctrl);
  if (stateView) return stateView;
  if (!ctrl.startView) return m('div')

  return m('div.mb2', [
    m('label', 'Select location:'),
    m('br'),
    m("div.mb2.pb2.bb.bw1.b--mid-gray.near-white", [
      m('div.dib-ns.mr2', { label: 'Home', onclick: ctrl.getLocations }),
      function () {
        if (ctrl.ancestors) {
          return ctrl.ancestors().map(function (ancestor, idx) {
            return m('div.dib-ns.mr2.pointer', {
              class: ancestor['@class'] === ctrl.actualLevel() ? "active" : "blue",
              onclick: () => {
                if (ancestor['@class'] === 'Home') ctrl.getLocations();
                if (ancestor['@class'] === 'Site') ctrl.navigateLocation(ancestor);
                if (ancestor['@class'] === 'Building') ctrl.navigateBuilding(ancestor);
              }
            }, [
              ancestor.name,
              ' / '
            ])
          })
        }
      }()
    ]),
    (() => {
      if (ctrl.actualLevel() === 'Home') {
        return m(paginationWithSearch, {
          data: [...ctrl.locations, ...ctrl.equipment],
          newNode: ctrl.newNode,
          dataToShow: ctrl.dataToShow
        }, [
          ctrl.dataToShow.map((record, idx) => {
            if(!record['@rid']) return;
            return m(verticalListItem, {
              label: m('span', [
                record.name || record['@class'],
                (Array.isArray(record.out_isSiteOf) && record.out_isSiteOf.length > 0) || 
                (Array.isArray(record.out_isLocationOf) && record.out_isLocationOf.length) ||
                (Array.isArray(record.out_hasComponent) && record.out_hasComponent.length > 0) ?
                  m('i', {
                    class: 'dark-blue ion-ios-arrow-right ml2 f3 b'
                  })
                  : ''
              ]),
              labelClass: 'dark-blue',
              onclickLabel: () => {
                if (
                  (Array.isArray(record.out_isSiteOf) && record.out_isSiteOf.length > 0) || 
                  (Array.isArray(record.out_isLocationOf) && record.out_isLocationOf.length)
                ) {
                  ctrl.navigateLocation(record);
                } else if (Array.isArray(record.out_hasComponent) && record.out_hasComponent.length > 0) {
                  ctrl.navigateEquipment(record);
                } else {
                  ctrl.selectNode(record);
                }
              }
            }, [
              m('i', {
                onclick: () => { ctrl.selectNode(record) },
                class: 'fr f3 b ' +
                  (ctrl.selectedNode() && ctrl.selectedNode()['@rid'] == record['@rid'] ? 'ion-ios-circle-filled' : 'ion-ios-circle-outline')
              })
            ]
            )
          })
        ])
      }
      if (ctrl.actualLevel() === 'Site') {
        return m(paginationWithSearch, {
          data: [...ctrl.buildings, ...ctrl.equipment],
          newNode: ctrl.newNode,
          dataToShow: ctrl.dataToShow
        }, [
          ctrl.dataToShow.map((record, idx) => {
            if(!record['@rid']) return;
            return m(verticalListItem, {
              label: m('span', [
                record.name || record['@class'],
                (Array.isArray(record.out_hasPart) && record.out_hasPart.length > 0) || 
                (Array.isArray(record.out_isLocationOf) && record.out_isLocationOf.length) || 
                (Array.isArray(record.out_hasComponent) && record.out_hasComponent.length > 0) ?
                  m('i', {
                    class: 'dark-blue ion-ios-arrow-right ml2 f3 b'
                  })
                  : ''
              ]),
              labelClass: 'dark-blue',
              onclickLabel: () => {
                if (
                  (Array.isArray(record.out_hasPart) && record.out_hasPart.length > 0) || 
                  (Array.isArray(record.out_isLocationOf) && record.out_isLocationOf.length)
                ) {
                  ctrl.navigateBuilding(record);
                } else if (Array.isArray(record.out_hasComponent) && record.out_hasComponent.length) {
                  ctrl.navigateEquipment(record);
                } else {
                  ctrl.selectNode(record);
                }
              }
            }, [
              m('i', {
                onclick: () => { ctrl.selectNode(record) },
                class: 'fr f3 b ' +
                  (ctrl.selectedNode() && ctrl.selectedNode()['@rid'] == record['@rid'] ? 'ion-ios-circle-filled' : 'ion-ios-circle-outline')
              })
            ])
          })
        ])
      }
      if (ctrl.actualLevel() === 'Building') {
        return m(paginationWithSearch, {
          data: [...ctrl.floors, ...ctrl.equipment],
          newNode: ctrl.newNode,
          dataToShow: ctrl.dataToShow
        }, [
          ctrl.dataToShow.map((record, idx) => {
            if(!record['@rid']) return;
            return m(verticalListItem, {
              label: m('span', [
                record.name || record['@class'],
                (Array.isArray(record.out_hasPart) && record.out_hasPart.length > 0) || 
                (Array.isArray(record.out_isLocationOf) && record.out_isLocationOf.length) ||
                (Array.isArray(record.out_hasComponent) && record.out_hasComponent.length > 0) ?
                  m('i', {
                    class: 'dark-blue ion-ios-arrow-right ml2 f3 b'
                  })
                  : ''
              ]),
              labelClass: 'dark-blue',
              onclickLabel: () => {
                if (
                  (Array.isArray(record.out_hasPart) && record.out_hasPart.length > 0) || 
                  (Array.isArray(record.out_isLocationOf) && record.out_isLocationOf.length)
                ) {
                  ctrl.navigateLevel(record);
                } else if (Array.isArray(record.out_hasComponent) && record.out_hasComponent.length > 0) {
                  ctrl.navigateEquipment(record);
                } else {
                  ctrl.selectNode(record);
                }
              }
            }, [
              m('i', {
                onclick: () => { ctrl.selectNode(record) },
                class: 'fr f3 b ' +
                  (ctrl.selectedNode() && ctrl.selectedNode()['@rid'] == record['@rid'] ? 'ion-ios-circle-filled' : 'ion-ios-circle-outline')
              })
            ])
          })
        ])
      }
      if (ctrl.actualLevel() === 'Level') {
        return m(paginationWithSearch, {
          data: [...ctrl.rooms, ...ctrl.equipment],
          newNode: ctrl.newNode,
          dataToShow: ctrl.dataToShow
        }, [
          ctrl.dataToShow.map((record, idx) => {
            if(!record['@rid']) return;
            return m(verticalListItem, {
              label: m('span', [
                record.name || record['@class'],
                (Array.isArray(record.out_hasPart) && record.out_hasPart.length > 0) || (Array.isArray(record.out_isLocationOf) && record.out_isLocationOf.length) ?
                  m('i', {
                    class: 'dark-blue ion-ios-arrow-right ml2 f3 b'
                  })
                  : ''
              ]),
              labelClass: 'dark-blue',
              onclickLabel: () => {
                if (record.out_isLocationOf && record.out_isLocationOf.length) {
                  ctrl.navigateEquipment(record);
                } else {
                  ctrl.selectNode(record)
                }
              }
            }, [
              m('i', {
                onclick: () => { ctrl.selectNode(record) },
                class: 'fr f3 b ' +
                  (ctrl.selectedNode() && ctrl.selectedNode()['@rid'] == record['@rid'] ? 'ion-ios-circle-filled' : 'ion-ios-circle-outline')
              })
            ])
          })
        ])
      }
      if (ctrl.actualLevel() === 'Equipment') {
        return m(paginationWithSearch, {
          data: ctrl.equipment,
          newNode: ctrl.newNode,
          dataToShow: ctrl.dataToShow
        }, [
          ctrl.dataToShow.map((equipment, idx) => {
            if(!equipment['@rid']) return;
            return m(verticalListItem, {
              label: m('span', [
                equipment.name || equipment['@class'],
                (Array.isArray(equipment.out_hasComponent) && equipment.out_hasComponent.length > 0) ?
                  m('i', {
                    class: 'dark-blue ion-ios-arrow-right ml2 f3 b'
                  })
                  : ''
              ]),
              labelClass: 'dark-blue',
              onclickLabel: () => {
                ctrl.selectNode(equipment)
              }
            }, [
              m('i', {
                onclick: () => { ctrl.selectNode(equipment) },
                class: 'fr f3 b ' +
                  (ctrl.selectedNode() && ctrl.selectedNode()['@rid'] == equipment['@rid'] ? 'ion-ios-circle-filled' : 'ion-ios-circle-outline')
              })
            ])
          })
        ])
      }
    })(),
  ])
}

module.exports = trees;
